import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import NavigationBar from '../nav_bar/navigation_bar';
import './projects.css';

const ProjectDetail = () => {
    const { id } = useParams();
    const [project, setProject] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjectDetails = async () => {
            try {
                setLoading(true);
                const projectsRes = await fetch('/upload/data/projects.json');
                const data = await projectsRes.json();
                const projects = data.projects ?? data;
                const found = projects.find((p) => p.id === id);
                setProject(found || null);
            } catch (err) {
                console.error('Failed to load project:', err);
                setProject(null);
            } finally {
                setLoading(false);
            }
        };
        fetchProjectDetails();
    }, [id]);

    if (loading) {
        return (
            <div className="project-detail-page">
                <NavigationBar />
                <div className="project-detail-container">
                    <div className="loading-state">
                        <p>Loading project...</p>
                        <Link to="/projects" className="back-link">← Back to Projects</Link>
                    </div>
                </div>
            </div>
        );
    }

    if (!project) {
        return (
            <div className="project-detail-page">
                <NavigationBar />
                <div className="project-detail-container">
                    <div className="empty-state">
                        <p>Project not found.</p>
                        <Link to="/projects" className="back-link">← Back to Projects</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="project-detail-page">
            <NavigationBar />
            <main className="project-detail-container">

                <Link to="/projects" className="back-link">← Back to Projects</Link>

                {/* Header */}
                <div className="project-detail-header">
                    <div className="project-detail-icon">{project.icon}</div>
                    <h1 className="project-detail-title">{project.title}</h1>
                    <p className="project-detail-description">{project.description}</p>
                </div>

                {/* Tags */}
                {project.tags && project.tags.length > 0 && (
                    <div className="project-detail-tags">
                        {project.tags.map((tag, index) => (
                            <span key={index} className="project-tag-detail">{tag}</span>
                        ))}
                    </div>
                )}

                <div className="project-detail-links">
                    {project.githubLink && (
                        <a
                            href={project.githubLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="detail-link github-link"
                        >
                            🔗 GitHub
                        </a>
                    )}
                    {project.liveLink && (
                        <a
                            href={project.liveLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="detail-link live-link"
                        >
                            🚀 Live Demo
                        </a>
                    )}
                </div>

                {/* Features */ }
    {
        project.features && project.features.length > 0 && (
            <section className="detail-section">
                <h2>Key Features</h2>
                <ul className="feature-list">
                    {project.features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                    ))}
                </ul>
            </section>
        )
    }

    <Link to="/projects" className="back-link">← Back to Projects</Link>

            </main >
        </div >
    );
};

export default ProjectDetail;